
export enum TCI_MARKUP_DISPLAY_MODE {
    MODE_VIEW,
    MODE_EDIT,
}

export class TCIMarkupEditorDisplaySize {
    public static TINY = new TCIMarkupEditorDisplaySize(100, 100);
    public static SMALL = new TCIMarkupEditorDisplaySize(100, 100);
    public static MEDIUM = new TCIMarkupEditorDisplaySize(100, 100);
    public static LARGE = new TCIMarkupEditorDisplaySize(100, 100);
    public static XLARGE = new TCIMarkupEditorDisplaySize(100, 100);

    private constructor(private width: number, private height: number) {
    }
}


export interface ITCIMarkupEditorContext {
    content: string;
    encoding?: string;
}
